import { Component, EventEmitter, Injector, Input, OnInit, Output } from "@angular/core";
import { Attachment } from "../../models/attachment";
import { AttachmentsService } from "../../services/attachments.service";
import { saveAs } from 'file-saver';
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { MailSender } from "../mail-sender/mail-sender.component";
import { Sended } from "../../models/mail-sender/sended";
import { UserGroup } from '../../../shared/models/user-group/user-group';
import { Request } from '../../../shared/models/request/request';
import { ImagePopupExtended } from "../image-popup-extended/image-popup-extended.component";
import { CustomerObjectsService } from "../../../categories/customer-objects/customer-objects.service";

@Component({
    selector: 'document-sender',
    templateUrl: './document-sender.component.html',
    styleUrls: [
        './document-sender.component.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})

export class DocumentSender implements OnInit  {

    constructor(
        private attachmentsService: AttachmentsService,
        private dialogService: DialogService,
        private injector: Injector,
        private customerObjectsService: CustomerObjectsService) { }

    @Input() requestId: number;
    @Input() fileId: number;
    @Output() mailSended: EventEmitter<Sended> = new EventEmitter();

    @Input() entity: Request;
    @Input() serviceCenter: string = ''
    @Input() userGroups: UserGroup[] = [];
    @Input() noBl: boolean = false;
    @Input() hidePreviousAndNexImageButtons: boolean = false;
    @Input() height: number = 680;
    @Input() canEditFinishFactDate: boolean = true;
	@Input() files: Attachment[] = [];
	@Input() doNotPrepareFiles: boolean = false;
    @Input() hideSendButton: boolean = false;

    private currentFile: Attachment;

    downloading: boolean;

    ngOnInit(): void {
        if (!this.doNotPrepareFiles) {
            this.files.forEach(f => {
                this.prepareFile(f.fileBase64, f);
            });
        }

        this.currentFile = this.files.find(f => f.attachmentId === this.fileId);
    }

    prepareFile(result: string | ArrayBuffer, file: Attachment) {
        var extension = file.attachmentExtension.toLowerCase();
        result = `data:application/octet-stream;base64,${result}`;
        var base64data = (result as string).split(',')[1];
        var image;
        switch (extension) {
            case ('.pdf'):
                {
                    image = result;
                    break;
                }
            default:
                image = `data:image/png;base64,${base64data}`;
                break;
        }

        file.fileBase64 = image;
    }

    downloadFile(): void {
        var self = this;
        this.downloading = true;
        this.attachmentsService.getAttachmentById(this.currentFile.attachmentId).subscribe(blob => {
            saveAs(blob, self.currentFile.attachmentName, { type: 'application/octet-stream' });
            this.downloading = false;
        });
    }

    async sendFile() {
        let customerObjects = await this.customerObjectsService.getCustomerObjectsByRequest(this.requestId).toPromise();
        let email = "";

        if (customerObjects && customerObjects.length > 0) {
            email = customerObjects[0].contragentEmail;
        }

        const dialogRef = this.dialogService.open({ content: MailSender, width: '50%', height: '210px', title: 'Отправка'});
					
        const documentSender = <MailSender>dialogRef.content.instance;

        documentSender.requestId = this.requestId;
        documentSender.email = email;
        documentSender.fileId = this.currentFile.attachmentId;
        documentSender.attachment = this.currentFile;
        documentSender.mailSended.subscribe((res: Sended) => {
            if (this.mailSended) {
                this.mailSended.emit(res);
            }

            this.closeDialog();
        });
    }

    closeDialog(): void {
        var dialog = this.injector.get(DialogRef);
        dialog.close();
    }

    onCurrentFile(file: Attachment): void {
        this.currentFile = file;
    }
}